import Viewport from '@vaersaagod/tools/Viewport';
import Components from '@vaersaagod/tools/Components';
import 'gsap';
import 'gsap/ScrollToPlugin';
import './lib/polyfills';
import lazySizes from './lib/lazysizes';

/*
*   Bootstrap app
*
 */
const init = () => {
    Viewport.init();
    Viewport.releaseTabbing();
    Components.init();
    lazySizes.init();
};

require('doc-ready')(() => {
    if (ENV === 'production') {
        init();
    } else {
        // Dev mode; check for styles before booting
        // Don't worry chief – this code will be stripped out of your production build <3
        const checkCSS = () => {
            if (getComputedStyle(document.body).boxSizing !== 'border-box') {
                requestAnimationFrame(checkCSS);
                return;
            }
            init();
        };
        checkCSS();
    }
});



// WEBPACK FOOTER //
// ./src/js/main.js